import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta-section');
    if (offerSection) {
      offerSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-top"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=advanced%20artificial%20intelligence%20neural%20network%20visualization%20with%20glowing%20orange%20and%20cyan%20data%20nodes%20on%20dark%20sophisticated%20background%2C%20futuristic%20technology%20command%20center%20with%20holographic%20displays%20and%20circuit%20patterns%2C%20premium%20digital%20intelligence%20hub%20atmosphere%20with%20dramatic%20lighting%20and%20depth%2C%20cinematic%20tech%20aesthetic%20with%20warm%20amber%20highlights%20and%20electric%20blue%20accents%2C%20professional%20high-end%20software%20interface%20environment&width=1920&height=1080&seq=hero-nexus-premium-v3-001&orientation=landscape')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#FAF9F6] shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="w-7 h-7 sm:w-9 sm:h-9 bg-[#FF6B00] rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-cpu-line text-white text-sm sm:text-lg"></i>
            </div>
            <span className={`text-base sm:text-xl font-black tracking-tight transition-colors ${scrolled ? 'text-[#0A0A0A]' : 'text-white'}`} style={{ fontFamily: 'Poppins, sans-serif' }}>
              Nexus<span className="text-[#FF6B00]"> DI</span>
            </span>
          </div>
          <button
            onClick={scrollToOffer}
            className="px-3 py-2 sm:px-6 sm:py-3 bg-[#FF6B00] text-white font-bold rounded-full hover:bg-[#e05e00] transition-all shadow-lg cursor-pointer text-xs sm:text-sm tracking-wide flex-shrink-0"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            <span className="hidden xs:inline">Obtén Acceso — S/ 25</span>
            <span className="inline xs:hidden leading-tight">Obtén Acceso<br />S/ 25</span>
          </button>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 min-h-screen flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-20 sm:pt-28 pb-12 sm:pb-20">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">

            {/* Left Column */}
            <div className="max-w-2xl">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-[#FF6B00]/20 backdrop-blur-sm border border-[#FF6B00]/40 rounded-full mb-4 sm:mb-5">
                <div className="w-2 h-2 bg-[#FF6B00] rounded-full animate-pulse"></div>
                <span className="text-white text-xs sm:text-sm font-semibold tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Tecnología Nivel NASA
                </span>
              </div>

              {/* Main Title */}
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-black text-white leading-[1.1] sm:leading-[1.05] mb-4 sm:mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Nexus Digital Intelligence:{' '}
                <span className="text-[#FF6B00]">La IA que los Gurús</span>{' '}
                no quieren que tengas
              </h1>

              {/* Subtitle */}
              <p className="text-sm sm:text-base md:text-xl text-white/90 leading-relaxed font-light mb-5 sm:mb-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Identifica <strong className="text-white font-semibold">productos ganadores</strong>, espía nichos rentables y genera{' '}
                <strong className="text-white font-semibold">creativos de nivel profesional</strong> en segundos.{' '}
                <span className="text-[#FF6B00] font-semibold">Acceso anual a precio de lanzamiento.</span>
              </p>

              {/* CTA Button */}
              <button
                onClick={scrollToOffer}
                className="group w-full sm:w-auto px-6 sm:px-10 py-4 sm:py-5 bg-[#FF6B00] text-white font-black rounded-full shadow-[0_8px_32px_rgba(255,107,0,0.55)] hover:shadow-[0_12px_40px_rgba(255,107,0,0.75)] hover:bg-[#e05e00] transition-all cursor-pointer flex items-center justify-center gap-3 text-sm sm:text-base md:text-lg mb-6 sm:mb-8 leading-snug text-center"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                <span className="hidden sm:inline">Obtén Acceso Anual — S/ 25</span>
                <span className="inline sm:hidden leading-tight">Obtén Acceso Anual<br />— S/ 25</span>
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-black/30 rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className="ri-arrow-right-line text-white text-base sm:text-xl"></i>
                </div>
              </button>

              {/* Trust Badges */}
              <div className="flex flex-wrap items-center gap-3 sm:gap-6">
                <div className="flex items-center gap-2 text-white/80">
                  <i className="ri-shield-check-fill text-[#FF6B00] text-base sm:text-xl"></i>
                  <span className="text-xs sm:text-sm font-light" style={{ fontFamily: 'Poppins, sans-serif' }}>Suscripción Anual</span>
                </div>
                <div className="flex items-center gap-2 text-white/80">
                  <i className="ri-time-line text-[#FF6B00] text-base sm:text-xl"></i>
                  <span className="text-xs sm:text-sm font-light" style={{ fontFamily: 'Poppins, sans-serif' }}>Acceso Inmediato</span>
                </div>
              </div>
            </div>

            {/* Right Column - Video Demo */}
            <div className="relative mt-6 lg:mt-0">
              <div className="absolute inset-0 bg-[#FF6B00]/15 blur-[100px] rounded-full pointer-events-none"></div>

              <div className="relative rounded-xl sm:rounded-2xl overflow-hidden shadow-[0_24px_80px_rgba(0,0,0,0.55),0_0_0_1px_rgba(255,255,255,0.08)]">
                {/* Browser-style top bar */}
                <div className="flex items-center gap-2 px-3 sm:px-4 py-2 sm:py-3 bg-black/60 backdrop-blur-md border-b border-white/10">
                  <div className="flex gap-1.5">
                    <div className="w-2 h-2 sm:w-3 sm:h-3 rounded-full bg-[#FF6B00]"></div>
                    <div className="w-2 h-2 sm:w-3 sm:h-3 rounded-full bg-white/30"></div>
                    <div className="w-2 h-2 sm:w-3 sm:h-3 rounded-full bg-white/30"></div>
                  </div>
                  <div className="flex-1 bg-white/5 rounded-md px-2 sm:px-3 py-1 ml-2 sm:ml-3">
                    <span className="text-white/50 text-[10px] sm:text-xs font-mono">Demo · Nexus Digital Intelligence</span>
                  </div>
                </div>

                {/* Vimeo Embed */}
                <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                  <iframe
                    src="https://player.vimeo.com/video/1173062185?badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0"
                    className="absolute inset-0 w-full h-full"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                    allowFullScreen
                    title="Nexus Digital Intelligence - Demo"
                  ></iframe>
                </div>
              </div>

              <div className="absolute -top-4 -right-4 sm:-top-6 sm:-right-6 w-16 h-16 sm:w-24 sm:h-24 bg-[#00D9FF]/20 rounded-full blur-2xl animate-pulse pointer-events-none"></div>
              <div className="absolute -bottom-4 -left-4 sm:-bottom-6 sm:-left-6 w-20 h-20 sm:w-32 sm:h-32 bg-[#FF6B00]/20 rounded-full blur-2xl animate-pulse pointer-events-none" style={{ animationDelay: '1s' }}></div>
            </div>

          </div>

          {/* Stats Row */}
          <div className="flex flex-wrap gap-4 sm:gap-8 md:gap-12 mt-10 sm:mt-16 pt-6 sm:pt-12 border-t border-white/10">
            {[
              { icon: 'ri-search-eye-line', value: 'Análisis', label: 'de nichos desatendidos' },
              { icon: 'ri-image-ai-line', value: 'Creativos', label: 'generados con IA' },
              { icon: 'ri-rocket-line', value: 'S/ 25', label: 'Suscripción Anual' },
            ].map((stat, index) => (
              <div key={index} className="flex items-center gap-2 sm:gap-4">
                <div className="w-9 h-9 sm:w-12 sm:h-12 bg-[#FF6B00]/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${stat.icon} text-[#FF6B00] text-lg sm:text-2xl`}></i>
                </div>
                <div>
                  <div className="text-lg sm:text-2xl font-black text-white" style={{ fontFamily: 'Poppins, sans-serif' }}>{stat.value}</div>
                  <div className="text-xs sm:text-sm text-white/60" style={{ fontFamily: 'Poppins, sans-serif' }}>{stat.label}</div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}